module.exports = __webpack_public_path__ + "static/media/thumbnail.fce54495.jpg";